import Step from "@mui/material/Step";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import StepLabel from "@mui/material/StepLabel";
import { StepIconProps } from "@mui/material/StepIcon";
import Stepper from "@mui/material/Stepper";
import Check from "@mui/icons-material/Check";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import { enumerateStages } from "logic/Navigation/NavigationHelper";
import { getStageKey, Stage } from "logic/Navigation/Stages";
import { getStage, StepId, getFirstStepOfStage } from "logic/Navigation/Steps";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  currentStep: StepId;
  setCurrentStep: (stepId: StepId) => void;
}

const allStages: Stage[] = enumerateStages();

const Root = styled("div")(() => ({
  width: "100%",
}));

const CustomStepLabel = styled(StepLabel)(() => ({
  "& .MuiStepLabel-label": {
    fontFamily: "var(--theme-fonts), 'Segoe UI', Arial, Helvetica, sans-serif",
  },
}));

const CustomConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    borderColor: "var(--primary-color)", 
    cursor: "default",
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    borderColor: "var(--primary-color)",
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const StepIconRoot = styled("div")(() => ({
  color: "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  "&.active": {
    color: "var(--primary-color)",
  },
}));

const Circle = styled("div")({
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: "currentColor",
});

const CheckIconStyled = styled(Check)(() => ({
  cursor: "pointer",
  color: "var(--primary-color)",
  zIndex: 1,
  fontSize: 18,
}));

function QontoStepIcon(props: StepIconProps) {
    const { active = false, completed = false } = props;
  
    return (
      <StepIconRoot className={clsx({ active })}>
        {completed ? <CheckIconStyled /> : <Circle />}
      </StepIconRoot>
    );
  }
  

export const BookingStageStepper: React.FC<Props> = ({ currentStep, setCurrentStep }) => {
  const currentStage = getStage(currentStep);
  const { t } = useTranslation();
  
  if (currentStage === null) return null;

  return (
    <Root>
      <Stepper
        activeStep={currentStage}
        alternativeLabel
        connector={<CustomConnector />}
      >
        {allStages.map((stageId) => (
          <Step
            key={stageId}
            onClick={() => {
              if (currentStage > stageId) {
                setCurrentStep(getFirstStepOfStage(stageId));
              }
            }}
          >
            <CustomStepLabel  StepIconComponent={QontoStepIcon}>
              {t(getStageKey(stageId))}
            </CustomStepLabel>
          </Step>
        ))}
      </Stepper>
    </Root>
  );
};
